import React, { memo } from "react";
import { renderRoutes } from "react-router-config";

import routes from "./router";

import store from "./store";

import AppHeader from "@/components/app-header";
import AppFooter from "components/app-footer";
import { Provider } from "react-redux";
import withWindowSize from "@/components/higher-order/withWindowSize";
import KTAppHeaderMobile from "./components/mobile-components/app-header-mobile";
import { HashRouter } from "react-router-dom";
import AppRoutes from "./AppRoutes";
import KTGlobal from "./components/global";
import KTAppTopPublicity from "./components/app-top-publicity";

import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { initGA, trackPageview } from "./ga";




const App = memo(({ windowSize }) => {
  
  return (
    <Provider store={store}>
      <HashRouter>
        <AppRoutes windowSize={windowSize}/>
      </HashRouter>
    </Provider>
  );
});

export default withWindowSize(App);
